/* eslint-disable no-unused-vars */
import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import useWindowSize from '@shared/hooks/windowSize'
// import { scoreCardSliderLoader } from '@shared/libs/allLoader'
// import ScorecardSlider from '@shared/components/scorecardSlider'
// import OnMouseAndScroll from '@shared/components/lazyLoad/onMouseAndScroll'
// import { REACT_APP_ENV } from '@shared/constants'

// const Layout = dynamic(() => import('@shared-components/layout'))
// const ScorecardSlider = dynamic(() => import('@shared-components/scorecardSlider'), { loading: () => scoreCardSliderLoader() })
// const HomeNav = dynamic(() => import('@shared-components/homeNav'))
// const Ads = dynamic(() => import('@shared/components/ads'), { ssr: false })
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
const RecommendedArticles = dynamic(() => import('@shared/components/widgets/recommendedArticles'))
const WeekQuotes = dynamic(() => import('@shared/components/widgets/weekQuotes'))
const StockWidget = dynamic(() => import('@shared/components/widgets/stock-widget'))
const WeatherWidget = dynamic(() => import('@shared/components/widgets/weather-widget'))
const TopCategories = dynamic(() => import('@shared/components/widgets/topCategories'))
const HomePageStories = dynamic(() => import('@shared/components/stories/homepage-stories'))

// const TopPicks = dynamic(() => import('@shared/components/widgets/topPicks'))
// const PromotionSmall = dynamic(() => import('@shared/components/adsPromotion/promotionSmall'), { ssr: false })
// const PromotionFull = dynamic(() => import('@shared/components/adsPromotion/promotionFull'), { ssr: false })
// const SeriesPointTable = dynamic(() => import('@shared/components/widgets/seriesPointTable'), { ssr: false })
// const SeriesKeyStats = dynamic(() => import('@shared/components/widgets/SeriesKeyStats'), { ssr: false })

function HomePageContent({ articles, children, widgetPosition, stories }) {
  const [width] = useWindowSize()
  // const [activeTab, setActiveTab] = useState('ar')

  return (
    <>
      {/* {width < 767 && (
        <Container>
          <PromotionFull isHomePagePromotion />
        </Container>
      )} */}
      {/* <Container className="d-none d-md-block mt-2" style={{ minHeight: '100px' }}> */}
        {/* {width > 767 && ( // Desktop top
          <Ads
            id="div-ad-gpt-138639789--0-Crictracker2022_Desktop_Top_970"
            adIdDesktop="Crictracker2022_Desktop_Top_970x90"
            dimensionDesktop={[970, 90]}
            className={'text-center'}
          />
        )} */}
      {/* </Container> */}
      <div className="common-section">
        <Container className={styles.homeContainer}>
          <Row className="gx-3">
            <Col lg={8} xl={9} className={styles.centerContent}>
              {/* <HomeNav active={activeTab} handleChange={(t) => setActiveTab(t)} /> */}
              {children()}
              <TopCategories />
              {/* <TopPicks /> */}
              <HomePageStories stories={stories}/>
            </Col>
            <Col lg={4} xl={3} className={`${styles.commonSidebar} common-sidebar bt-width d-none d-lg-block`}>
              {width > 991 && (
                <>
                  <WeatherWidget/>
                  <RecommendedArticles />
                  <WeekQuotes />
                  <StockWidget/>
                  <AllWidget show={true} position="r" widgetPosition={widgetPosition} />
                </>
              )}
              {width > 991 && (
                <>
                  <AllWidget show={true} position="l" widgetPosition={widgetPosition} />
                  {/* <Ads
                    id="div-ad-gpt-138639789-1660055716-Desktop_HP_LeftBTF-1"
                    adIdDesktop="Crictracker2022_Desktop_HP_LeftBTF_300x600"
                    dimensionDesktop={[300, 600]}
                    className="sticky-ads position-sticky mb-2"
                  /> */}
                </>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}
HomePageContent.propTypes = {
  children: PropTypes.func,
  articles: PropTypes.array,
  widgetPosition: PropTypes.array,
  stories: PropTypes.array
}
export default HomePageContent
